import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import { getError, getMembershipLabel } from "../utils";

export default function MembershipListScreen() {
  const [memberships, setMemberships] = useState([]);
  const [filteredMemberships, setFilteredMemberships] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMembership, setSelectedMembership] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);

  // Form state for updating membership fields
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [endDate, setEndDate] = useState("");

  const { state } = useContext(Store);
  const { userInfo } = state;

  useEffect(() => {
    const fetchMemberships = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get("/api/busers/memberships", {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        });
        setMemberships(data);
        setFilteredMemberships(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchMemberships();
  }, [userInfo.token]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = memberships.filter((membership) => {
      const ownerName = membership.businessOwner?.name?.toLowerCase() || "";
      const email = membership.email?.toLowerCase() || "";
      const phone = membership.phone?.toLowerCase() || "";
      return (
        ownerName.includes(value) ||
        email.includes(value) ||
        phone.includes(value)
      );
    });

    setFilteredMemberships(filtered);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMembership(null);
  };

  const handleRowClick = (membership) => {
    setSelectedMembership(membership);
    setEmail(membership.email || "");
    setPhone(membership.phone || "");
    setEndDate(
      membership.endDate
        ? new Date(membership.endDate).toISOString().split("T")[0]
        : ""
    );
    setShowModal(true);
    setShowUserModal(false);
  };

  const handleUpdate = async () => {
    try {
      await axios.put(
        `/api/busers/memberships/${selectedMembership._id}`,
        {
          email,
          phone,
          endDate,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        }
      );
      // Update memberships in state to reflect the updated values
      setMemberships((prevMemberships) =>
        prevMemberships.map((membership) =>
          membership._id === selectedMembership._id
            ? { ...membership, email, phone, endDate }
            : membership
        )
      );
      setFilteredMemberships((prevMemberships) =>
        prevMemberships.map((membership) =>
          membership._id === selectedMembership._id
            ? { ...membership, email, phone, endDate }
            : membership
        )
      );
      handleCloseModal();
    } catch (err) {
      toast.error(getError(err));
      setError("Failed to update membership. Please try again.");
    }
  };

  return (
    <div className="container">
      <h1 className="my-3">Üyelikler</h1>

      {/* Arama Çubuğu */}
      <Form className="mb-3">
        <Form.Control
          type="text"
          placeholder="İşletme Sahibi Adı, E-posta veya Telefon ile Ara"
          value={searchTerm}
          onChange={handleSearch}
        />
      </Form>

      {loading ? (
        <div>Yükleniyor...</div>
      ) : (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Üyelik Adı</th>
              <th>İşletme Sahibi Adı</th>
              <th>E-posta</th>
              <th>Telefon</th>
              <th>Başlangıç/Bitiş Tarihi</th>
              <th>Durum</th>
              <th>Kullanıcı Sayısı</th>
            </tr>
          </thead>
          <tbody>
            {filteredMemberships.map((membership, index) => (
              <tr key={membership._id}>
                <td>{index + 1}</td>
                <td>{getMembershipLabel(membership.name)}</td>
                <td>
                  <div>
                    <Link to="#" onClick={() => handleRowClick(membership)}>
                      {membership.businessOwner?.name || "N/A"}
                    </Link>
                  </div>
                  <div>
                    <strong>{membership.businessOwner.businessName}</strong>
                  </div>
                </td>
                <td>{membership.email}</td>
                <td>{membership.phone}</td>
                <td>
                  <div>
                    {membership.startDate
                      ? new Date(membership.startDate).toLocaleDateString()
                      : "N/A"}
                  </div>

                  <div>
                    {membership.endDate
                      ? new Date(membership.endDate).toLocaleDateString()
                      : "N/A"}
                  </div>
                </td>

                <td>{membership.active ? "Aktif" : "Pasif"}</td>
                <td>
                  <Link
                    to="#"
                    onClick={() => {
                      setSelectedMembership(membership);
                      setShowUserModal(true);
                    }}
                  >
                    {membership.businessUsers.length}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {selectedMembership && showModal && (
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Üyelik Güncelle</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>E-posta</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formPhone">
                <Form.Label>Telefon</Form.Label>
                <Form.Control
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formEndDate">
                <Form.Label>Bitiş Tarihi</Form.Label>
                <Form.Control
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Kapat
            </Button>
            <Button variant="primary" onClick={handleUpdate}>
              Güncelle
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {selectedMembership && showUserModal && (
        <Modal
          show={showUserModal}
          onHide={() => {
            setShowUserModal(false);
            setSelectedMembership(null);
          }}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedMembership.businessOwner?.businessName} için İşletme
              Kullanıcıları
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedMembership.businessUsers?.length > 0 ? (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Adı</th>
                    <th>E-posta</th>
                    <th>Telefon</th>
                    <th>İşletme Adı</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedMembership.businessUsers.map((user, index) => (
                    <tr key={user._id}>
                      <td>{index + 1}</td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.phone}</td>
                      <td>{user.businessName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div>Bu üyelik için işletme kullanıcısı bulunamadı.</div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowUserModal(false);
                setSelectedMembership(null);
              }}
            >
              Kapat
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}
